import { Headers } from '@angular/http';

export const contentHeaders = new Headers();
 contentHeaders.append('Content-Type', 'multipart/form-data');
 contentHeaders.append('Accept', 'application/json');
 export const WebURL ="https://admin.smart-study.at";
export const APIURL ="https://admin.smart-study.at/API/index.php/";
export const IMAGEURL ="https://admin.smart-study.at/API/img/";
export const JsonURL ="https://admin.smart-study.at/API/";
 /*
 export const WebURL ="http://newadmin.smart-study.at";
export const APIURL ="http://newadmin.smart-study.at/API/index.php/";
export const IMAGEURL ="http://newadmin.smart-study.at/API/img/";
export const JsonURL ="http://newadmin.smart-study.at/API/";

export const APIURL ="http://localhost/SSAPI/index.php/";
export const IMAGEURL ="http://localhost/SSAPI/img/";
export const JsonURL ="http://localhost/SSAPI/";
*/
export interface UserInfo {
     UserId: number;
    Username: string;
    UserFullName: string;
    Type: string;
    Isblock: number;
    createdBy: string;
    Photo: number;
    phoneNo: string;
    gender: string;
    DOB: string;
    Education: string;
    Father_Name: string;
    Mother_Name: string;
};



// WEBPACK FOOTER //
// ./src/app/common/headers.ts